import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { EmployerFormFields } from 'src/@types';
import { Grid, GridItem, Heading } from '@chakra-ui/react';
import { DynamicInput } from 'src/components/shared/form-elements';
import { employerStatementFormFields } from '../config';
import { validationMessages } from 'src/components/shared/validation/validation-messages';

export const EmployerStatementEmployeeSection = ({
  heading,
  register,
  errors
}: {
  heading: string;
  register: UseFormRegister<EmployerFormFields>;
  errors: FieldErrors<EmployerFormFields>;
}) => {
  return (
    <>
      <Heading size={`md`}>{heading}</Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)'
        }}
        gap={4}>
        {/*<GridItem colSpan={{ base: 1, md: 2 }}>
          <<DynamicInput
            type={employerStatementFormFields.werknemersaanspreekvorm.type}
            id={employerStatementFormFields.werknemersaanspreekvorm.fieldName}
            label={employerStatementFormFields.werknemersaanspreekvorm.label}
            validation={{ required: validationMessages.required }}
            defaultValue={values.werknemersaanspreekvorm}
            register={register}
            options={[
              {
                label: 'Man',
                value: 'Man'
              },
              {
                label: 'Vrouw',
                value: 'Vrouw'
              }
            ]}
          />
        </GridItem>*/}

        <DynamicInput
          id={employerStatementFormFields.werknemersnaam.fieldName}
          label={employerStatementFormFields.werknemersnaam.label}
          type={employerStatementFormFields.werknemersnaam.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.werknemersnaam.tooltip}
          error={errors.werknemersnaam}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.werknemersadres.fieldName}
          label={employerStatementFormFields.werknemersadres.label}
          type={employerStatementFormFields.werknemersadres.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.werknemersadres.tooltip}
          error={errors.werknemersadres}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.werknemerspostcode.fieldName}
          label={employerStatementFormFields.werknemerspostcode.label}
          type={employerStatementFormFields.werknemerspostcode.type}
          placeholder={employerStatementFormFields.werknemerspostcode.placeHolder}
          validation={{
            required: validationMessages.required,
            minLength: { value: 5, message: validationMessages.minLength(5) },
            maxLength: { value: 13, message: validationMessages.maxLength(13) }
            //validate: (value: string) => isValidZipcode(value, validationMessages.zipCode)
          }}
          tooltip={employerStatementFormFields.werknemerspostcode.tooltip}
          error={errors.werknemerspostcode}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.werknemerswoonplaats.fieldName}
          label={employerStatementFormFields.werknemerswoonplaats.label}
          type={employerStatementFormFields.werknemerswoonplaats.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.werknemerswoonplaats.tooltip}
          error={errors.werknemerswoonplaats}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.werknemersgeboortedatum.fieldName}
          label={employerStatementFormFields.werknemersgeboortedatum.label}
          type={employerStatementFormFields.werknemersgeboortedatum.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.werknemersgeboortedatum.tooltip}
          error={errors.werknemersgeboortedatum}
          register={register}
        />

        <DynamicInput
          id={employerStatementFormFields.werknemersindiensttreding.fieldName}
          label={employerStatementFormFields.werknemersindiensttreding.label}
          type={employerStatementFormFields.werknemersindiensttreding.type}
          validation={{ required: validationMessages.required }}
          tooltip={employerStatementFormFields.werknemersindiensttreding.tooltip}
          error={errors.werknemersindiensttreding}
          register={register}
        />

        <GridItem colSpan={{ base: 1, md: 2 }}>
          <DynamicInput
            id={employerStatementFormFields.werknemersfunctie.fieldName}
            label={employerStatementFormFields.werknemersfunctie.label}
            type={employerStatementFormFields.werknemersfunctie.type}
            validation={{ required: validationMessages.required }}
            tooltip={employerStatementFormFields.werknemersfunctie.tooltip}
            error={errors.werknemersfunctie}
            register={register}
          />
        </GridItem>
      </Grid>
    </>
  );
};
